import { TriangleSmallDownIcon } from './TriangleSmallDownIcon';

/**
 * author: Jeff Anders
 * id C5F5CD46-5905-406B-8C0B-7109E8393218
 * name triangle-small-down
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/triangle-small-down.svg
 * tags
 * - Shape 
 */
export const TrendingDownVariantIcon = TriangleSmallDownIcon;
export default TrendingDownVariantIcon